import React, {
    useState,
    useRef,
    useLayoutEffect,
    useEffect,
} from "react"
import "swiper/css"
import "swiper/css/autoplay"
import RyderLivescoringSessionNin9rsView from "@/components/RyderLivescoring/views/nin9rs/RyderLivescoringSessionNin9rsView"
import RyderLivescoringSessionDefaultView from "@/components/RyderLivescoring/views/default/RyderLivescoringSessionDefaultView"

const colorMapping = {
    ["blue"]: "#0000b3",
    ["red"]: "#ff3131",
    ["yellow"]: "#ffde59",
    ["green"]: "#007a3f",
    ["black"]: "#000",
    ["orange"]: "#ff751f",
    ["pink"]: "#f9a",
    ["purple"]: "#b300b2",
    ["fuchsia"]: "#fa009a",
    ["cyan"]: "#5ce1e6",
}

const RyderLivescoringSession = ({
    session,
    teamColors,
    teams,
    showHeader = true,
    headerName = null,
    hideModality = false,
    customDesign
}) => {
    let nin9rsTeamColors = {}
    Object.entries(teamColors).map(([key, value]) => {
        nin9rsTeamColors[key] = colorMapping[value] || colorMapping["black"]
    })

    const [isMobile, setIsMobile] = useState(
        typeof window !== "undefined" && window.innerWidth < 640
    )

    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth < 640)
        window.addEventListener("resize", onResize)
        return () => window.removeEventListener("resize", onResize)
    }, [])
    const useSwiper = !isMobile

    const designTeamColors = "nin9rs" === customDesign ? nin9rsTeamColors : teamColors

    const teamIds = Object.keys(designTeamColors)
    const colors = Object.values(designTeamColors)

    const wrapperRef = useRef(null)
    const matchCardRef = useRef(null)
    const swiperRef = useRef(null)

    const [maxWrapperHeight, setMaxWrapperHeight] = useState(0)
    const [cardHeight, setCardHeight] = useState(0)
    const [maxCount, setMaxCount] = useState(1)

    useLayoutEffect(() => {
        const SPACE = 10
        const measure = () => {
            if (!wrapperRef.current || !matchCardRef.current) return
            const wrapH = wrapperRef.current.clientHeight
            const cardH = matchCardRef.current.offsetHeight
            const count = Math.max(1, Math.floor(wrapH / cardH))
            setMaxWrapperHeight(wrapH)
            setCardHeight(cardH)
            setMaxCount(count)
            swiperRef.current?.update()
        }
        const raf = requestAnimationFrame(measure)
        window.addEventListener("resize", measure)
        return () => {
            cancelAnimationFrame(raf)
            window.removeEventListener("resize", measure)
        }
    }, [showHeader])

    const slideCount = Math.min(maxCount, Math.max(session.matches.length, 1) + 10)

    useEffect(() => {
        const s = swiperRef.current
        if (!s) return
        if (session.matches.length >= 3) {
            s.autoplay.start()
        } else {
            s.autoplay.stop()
        }
    }, [session.matches.length])

    const resume = useRef(null)
    const onWheel = () => {
        const s = swiperRef.current
        if (!s) return
        s.params.autoplay.delay = 250
        s.autoplay.stop()
        s.autoplay.start()
        clearTimeout(resume.current)
        resume.current = setTimeout(() => {
            s.params.autoplay.delay = 10000
            s.autoplay.stop()
            s.autoplay.start()
        }, 5000)
    }
    useEffect(() => () => clearTimeout(resume.current), [])

    const wrapperStyle = { height: "100%" }

    if ("nin9rs" === customDesign) {
        return <RyderLivescoringSessionNin9rsView
            teams={teams}
            session={session}
            teamIds={teamIds}
            showHeader={showHeader}
            headerName={headerName}
            hideModality={hideModality}
            colors={colors}
            useSwiper={useSwiper}
            wrapperStyle={wrapperStyle}
            wrapperRef={wrapperRef}
            slideCount={slideCount}
            matchCardRef={matchCardRef}
            onWheel={onWheel}
            swiperRef={swiperRef}
            customDesign={customDesign}
            teamColors={designTeamColors}
        />
    } else {
        return <RyderLivescoringSessionDefaultView
            teams={teams}
            session={session}
            teamIds={teamIds}
            showHeader={showHeader}
            headerName={headerName}
            hideModality={hideModality}
            colors={colors}
            useSwiper={useSwiper}
            wrapperStyle={wrapperStyle}
            wrapperRef={wrapperRef}
            slideCount={slideCount}
            matchCardRef={matchCardRef}
            onWheel={onWheel}
            swiperRef={swiperRef}
            customDesign={customDesign}
            teamColors={designTeamColors}
        />
    }
}

export default RyderLivescoringSession
